import { jsx as t, jsxs as m, Fragment as U } from "react/jsx-runtime";
import { withManagedProps as S } from "@made-people/managed-props";
import { z as e } from "zod";
import { withZod as g } from "@made-people/react-prop-guard";
import { searchAutocompleteBlueprint as ee, searchInputBlueprint as te, searchShanghaiBlueprint as ae, searchBeijingBlueprint as oe, categorySuggestionsListBlueprint as ne, linkSuggestionsListBlueprint as ie, phraseSuggestionListBlueprint as se, searchProductListBlueprint as re, recentSearchesListBlueprint as le, searchResultsHeaderBlueprint as ce } from "./index-blueprint.es.js";
import { useTranslate as f } from "@made-people/grease-translations";
import { useState as A, useCallback as ue, useRef as pe, useEffect as T } from "react";
import { MagnifierIcon as me, AnimatedLoaderIcon as de } from "@made-people/blueprint-icons";
import { useNavigate as he, useHref as ge } from "@made-people/grease-link";
import { ProductProvider as O, ProductLink as ye } from "@made-people/grease-product";
import { useAutoCompleteSearch as Se, useSearchResultItems as G, useFacets as fe } from "@made-people/grease-search";
import { headingSchema as v, Heading as L } from "@made-people/blueprint-heading";
import { AnimatePresence as H, motion as R } from "motion/react";
import { ResponsiveImage as K } from "@made-people/blueprint-responsive-image";
import { ProductCard as V } from "@made-people/blueprint-product-card";
import be from "clsx";
import { useFloating as Ne, size as ve, autoUpdate as Le, FloatingPortal as je } from "@floating-ui/react";
import { ProductList as Z } from "@made-people/blueprint-product-list";
import { componentWrapperLayoutSchema as F, ComponentWrapper as I, componentWrapperSchema as Ce } from "@made-people/blueprint-component-wrapper";
import "@made-people/blueprint";
const ke = ({
  state: a,
  slots: n
}) => {
  const l = f();
  if (!a)
    return null;
  let r = "";
  return a === "first-use" ? r = l("Autocomplete_startTyping") : a === "user-cleared" ? r = l("Autocomplete_suggestionsCleared") : a === "error" ? r = l("Autocomplete_somethingWrong") : a === "no-results" && (r = l("Autocomplete_noResults")), /* @__PURE__ */ t("div", { className: n.emptyStateWrapper, children: /* @__PURE__ */ t("h3", { className: n.emptyStateHeading, children: r }) });
}, _e = e.object({
  variants: e.custom().optional(),
  searchQuery: e.string().optional(),
  isVisible: e.boolean().optional(),
  heading: v.optional(),
  onLinkClick: e.function().optional(),
  onLoadingStateChange: e.custom().optional(),
  elementRef: e.custom().optional(),
  enableEmptyState: e.boolean().optional(),
  style: e.custom().optional(),
  typeOfCard: e.literal("product").or(e.literal("small")).optional()
}), Pe = S(
  "SearchAutocomplete",
  g(
    _e,
    ({
      searchQuery: a,
      isVisible: n = !1,
      heading: l,
      onLoadingStateChange: r,
      elementRef: c,
      onLinkClick: o,
      style: i,
      enableEmptyState: s = !0,
      typeOfCard: u,
      variants: j
    }) => {
      const [P, N] = A(n), d = ee.styles(j), [p, C] = A([]), { execute: q, loadingState: B } = Se(), w = ue(q, []), M = f(), b = pe();
      T(() => {
        r && r(B);
      }, [B, r]), T(() => {
        n ? p != null && p.length && !s ? N(!0) : N(!!s) : N(!1);
      }, [n, p]), T(() => {
        if (!(a != null && a.trim())) {
          C([]);
          return;
        }
        return b.current && clearTimeout(b.current), b.current = setTimeout(async () => {
          try {
            const { productSuggestions: h } = await w({
              searchQuery: a.trim(),
              limit: 10
            });
            C(h);
          } catch (h) {
            console.error(h);
          }
        }, 300), () => {
          b.current && clearTimeout(b.current);
        };
      }, [a, w]);
      const z = p.length === 0 && a, y = p.length === 0 && !a;
      return /* @__PURE__ */ t(H, { children: P && /* @__PURE__ */ m(
        R.div,
        {
          ref: c,
          style: i,
          className: d.wrapper,
          onMouseDown: (h) => h.preventDefault(),
          layout: "position",
          initial: { opacity: 0, y: -40 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.4, ease: [0.68, -0.55, 0.27, 1.55] },
          children: [
            /* @__PURE__ */ t(L, { className: d.heading, ...l }),
            /* @__PURE__ */ m("div", { className: d.resultList, children: [
              s ? B === "loading" ? /* @__PURE__ */ t("span", { className: d.loading, children: M("Autocomplete_loading") }) : /* @__PURE__ */ t(
                ke,
                {
                  slots: d,
                  state: z ? "no-results" : y ? "first-use" : null
                }
              ) : null,
              p.map((h, k) => {
                const x = h.base.content.media.find(
                  (W) => W.type === "image"
                );
                return u === "product" ? /* @__PURE__ */ t(
                  O,
                  {
                    product: h,
                    context: {
                      type: "plp",
                      listId: "search-autocomplete",
                      listName: "Search Autocomplete",
                      position: k
                    },
                    children: /* @__PURE__ */ t(V, {})
                  },
                  k
                ) : /* @__PURE__ */ t(
                  O,
                  {
                    product: h,
                    context: {
                      type: "plp",
                      position: k
                    },
                    children: /* @__PURE__ */ t(
                      "div",
                      {
                        className: "contents",
                        onClick: (W) => {
                          o && o();
                        },
                        children: /* @__PURE__ */ m(
                          ye,
                          {
                            productBase: h.base,
                            className: d.item,
                            context: "product-card",
                            children: [
                              x ? /* @__PURE__ */ t(
                                K,
                                {
                                  initial: { src: x.src },
                                  displaySize: "40px",
                                  className: d.itemImage
                                }
                              ) : null,
                              /* @__PURE__ */ t("span", { className: d.itemLabel, children: h.base.content.name })
                            ]
                          }
                        )
                      },
                      k
                    )
                  },
                  k
                );
              })
            ] })
          ]
        }
      ) });
    }
  )
), $ = e.object({
  variants: e.custom().optional(),
  placeholder: e.object({
    enabled: e.boolean().optional(),
    text: e.string().optional()
  }).optional(),
  icons: e.object({
    search: e.union([e.custom(), e.literal(!1)]).optional(),
    loading: e.union([e.custom(), e.literal(!1)]).optional()
  }).optional(),
  className: e.string().optional(),
  autoComplete: e.object({
    enabled: e.boolean().optional()
  }).optional(),
  autoFocus: e.boolean().optional(),
  clear: e.object({
    enabled: e.boolean().optional(),
    text: e.string().optional()
  }).optional(),
  searchResultsCallback: e.function().args(e.string()).optional(),
  feedbackQuery: e.string().optional(),
  onSubmitCallback: e.function().optional().describe("Callback function to be called on submit")
}), D = S(
  "SearchInput",
  g(
    {
      schema: $,
      defaultProps: {
        icons: { search: /* @__PURE__ */ t(me, {}), loading: /* @__PURE__ */ t(de, {}) },
        autoComplete: {
          enabled: !1
        },
        autoFocus: !1
      }
    },
    ({
      variants: a,
      placeholder: n,
      className: l,
      autoComplete: r,
      autoFocus: c,
      icons: o,
      clear: i,
      searchResultsCallback: s,
      feedbackQuery: u,
      onSubmitCallback: j
    }) => {
      const P = he(), N = ge(), d = te.styles(a), [p, C] = A(""), [q, B] = A(!1), [w, M] = A(""), { refs: b, floatingStyles: z } = Ne({
        strategy: "fixed",
        placement: "bottom-start",
        middleware: [
          ve({
            apply({ rects: _, elements: Q }) {
              Object.assign(Q.floating.style, {
                minWidth: `${_.reference.width}px`
              });
            }
          })
        ],
        // Add autoUpdate to handle window resizing
        whileElementsMounted: Le
      }), y = b.reference.current, k = (n == null ? void 0 : n.enabled) ?? !0 ? (n == null ? void 0 : n.text) ?? "Search" : void 0, x = (_) => {
        _.preventDefault(), p.trim() && (P(N("search?q=" + p)), C(""), y == null || y.blur(), j && j());
      }, W = (_) => {
        C(_);
      };
      T(() => {
        u && C(u);
      }, [u]), T(() => {
        s && s(p);
      }, [p]);
      const E = () => {
        C(""), y == null || y.focus();
      };
      return /* @__PURE__ */ m("div", { className: be(d.wrapper, l), children: [
        /* @__PURE__ */ m("form", { onSubmit: x, className: "contents", children: [
          /* @__PURE__ */ t(
            "input",
            {
              ref: b.setReference,
              type: "search",
              inputMode: "search",
              className: d.inputField,
              placeholder: k,
              value: p,
              onChange: (_) => W(_.target.value),
              onFocus: () => B(!0),
              onBlur: () => B(!1),
              enterKeyHint: "search",
              autoComplete: "off",
              autoCorrect: "off",
              spellCheck: "false",
              autoFocus: c
            }
          ),
          (i == null ? void 0 : i.enabled) && (i == null ? void 0 : i.text) && p.trim() && /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: d.clearText,
              onClick: () => E(),
              children: i == null ? void 0 : i.text
            }
          ),
          (o == null ? void 0 : o.search) && /* @__PURE__ */ t(
            "button",
            {
              type: "submit",
              className: d.iconSearch,
              disabled: !p.trim(),
              children: o == null ? void 0 : o.search
            }
          ),
          w === "loading" && (o == null ? void 0 : o.loading) && /* @__PURE__ */ t("div", { className: d.iconLoading, children: o == null ? void 0 : o.loading })
        ] }),
        (r == null ? void 0 : r.enabled) && /* @__PURE__ */ t(je, { children: /* @__PURE__ */ t(
          "div",
          {
            ref: b.setFloating,
            style: z,
            className: "z-50",
            children: /* @__PURE__ */ t(
              Pe,
              {
                isVisible: q,
                searchQuery: p,
                onLinkClick: () => y == null ? void 0 : y.blur(),
                onLoadingStateChange: M
              }
            )
          }
        ) })
      ] });
    }
  )
), J = e.object({
  template: e.literal("shanghai"),
  variants: e.custom().optional(),
  searchTerm: e.string().optional(),
  // Type errors if using productListSchema
  productListSettings: e.any().optional(),
  searchInputSettings: $.optional(),
  NoResultsComponent: e.custom().optional(),
  showNoResultsComponent: e.boolean().optional()
}), Be = S(
  "SearchAsShanghai",
  g(
    J,
    ({
      variants: a,
      searchTerm: n,
      searchInputSettings: l,
      productListSettings: r,
      NoResultsComponent: c,
      showNoResultsComponent: o
    }) => {
      const i = ae.styles(a), s = f();
      return /* @__PURE__ */ m(U, { children: [
        /* @__PURE__ */ t("h1", { className: i.heading, children: o ? s("Search_No_Results", {
          query: n ?? ""
        }) : s("Search_Title", { query: n ?? "" }) }),
        /* @__PURE__ */ t("div", { className: i.searchInputWrapper, children: /* @__PURE__ */ t(
          D,
          {
            variants: {
              color: "grey"
            },
            ...l
          }
        ) }),
        !o && /* @__PURE__ */ t(
          Z,
          {
            filter: {
              enabled: !0
            },
            ...r
          }
        ),
        o && c && c
      ] });
    }
  )
), X = e.object({
  template: e.literal("beijing"),
  variants: e.custom().optional(),
  searchTerm: e.string().optional(),
  // Type errors if using productListSchema
  productListSettings: e.any().optional(),
  searchInputSettings: $.optional(),
  NoResultsComponent: e.custom().optional(),
  heading: v.optional(),
  showNoResultsComponent: e.boolean().optional()
}), He = S(
  "SearchAsBeijing",
  g(
    X,
    ({
      variants: a,
      searchTerm: n,
      searchInputSettings: l,
      productListSettings: r,
      NoResultsComponent: c,
      heading: o,
      showNoResultsComponent: i
    }) => {
      const s = oe.styles(a), u = f();
      return /* @__PURE__ */ m(U, { children: [
        /* @__PURE__ */ m("div", { className: s.upperSectionWrapper, children: [
          /* @__PURE__ */ t(
            D,
            {
              variants: {
                color: "grey"
              },
              ...l
            }
          ),
          n && n.length > 0 ? /* @__PURE__ */ t("h1", { className: s.heading, children: u("Search_Title", { query: n }) }) : o ? /* @__PURE__ */ t("div", { className: s.noResultsHeadingWrapper, children: /* @__PURE__ */ t(L, { ...o }) }) : null
        ] }),
        !i && /* @__PURE__ */ t(
          Z,
          {
            filter: {
              enabled: !0
            },
            ...r
          }
        ),
        i && c
      ] });
    }
  )
), Y = e.discriminatedUnion("template", [
  J,
  X
]), Re = g(Y, (a) => {
  const n = G(), { activeFacetValues: l } = fe(), r = n && n.length === 0 && l.length === 0;
  switch (a.template) {
    case "shanghai":
      return /* @__PURE__ */ t(Be, { ...a, showNoResultsComponent: r });
    case "beijing":
      return /* @__PURE__ */ t(He, { ...a, showNoResultsComponent: r });
    default:
      return null;
  }
}), Ie = "shanghai", Ae = e.object({
  searchTerm: e.string().optional(),
  templateProps: Y.optional()
}), it = S(
  "Search",
  g(
    {
      schema: Ae,
      defaultProps: {}
    },
    (a) => {
      const n = a.templateProps || {
        template: Ie
      };
      return /* @__PURE__ */ t(Re, { ...n, searchTerm: a.searchTerm });
    }
  )
), Te = e.object({
  categorySuggestions: e.custom(),
  settings: e.object({
    heading: v.optional(),
    layout: F.optional()
  }).optional().describe("Settings for the category suggestions section"),
  clickHandler: e.function().args(e.string()).returns(e.void()).optional(),
  variants: e.custom().optional()
}), st = S(
  "CategorySuggestionsList",
  g(
    Te,
    ({ settings: a, categorySuggestions: n, clickHandler: l, variants: r }) => {
      const c = f(), o = ne.styles(r);
      return /* @__PURE__ */ m(I, { layout: a == null ? void 0 : a.layout, children: [
        /* @__PURE__ */ t(
          L,
          {
            className: o.categorySuggestionsHeading,
            heading: c("Category_Suggestions_Heading"),
            ...a == null ? void 0 : a.heading
          }
        ),
        /* @__PURE__ */ t("ul", { className: o.categorySuggestions, children: /* @__PURE__ */ t(H, { mode: "popLayout", children: n.map((i, s) => {
          var u, j;
          return /* @__PURE__ */ t(
            R.div,
            {
              initial: { opacity: 0, y: 10 },
              animate: { opacity: 1, y: 0 },
              exit: { opacity: 0, y: 10 },
              transition: {
                duration: 0.2,
                delay: s * 0.05
              },
              children: /* @__PURE__ */ t("li", { children: /* @__PURE__ */ t(
                "button",
                {
                  type: "button",
                  className: o.categorySuggestionsButton,
                  onClick: () => l && l(i.url),
                  children: /* @__PURE__ */ m("div", { className: o.categorySuggestionsContent, children: [
                    i.images && i.images.length > 0 && /* @__PURE__ */ t(
                      "div",
                      {
                        className: o.categorySuggestionsImageContainer,
                        children: /* @__PURE__ */ t(
                          K,
                          {
                            image: {
                              src: ((u = i.images[0]) == null ? void 0 : u.src) ?? "",
                              alt: ((j = i.images[0]) == null ? void 0 : j.alt) ?? ""
                            },
                            className: o.categorySuggestionsImage
                          }
                        )
                      }
                    ),
                    i.ancestors && i.ancestors.length > 0 && /* @__PURE__ */ t("div", { className: o.categorySuggestionsAncestors, children: i.ancestors.map(
                      (P, N) => /* @__PURE__ */ m("span", { children: [
                        N > 0 && /* @__PURE__ */ t("span", { className: "mx-1", children: "›" }),
                        P.title
                      ] }, P.url)
                    ) }),
                    /* @__PURE__ */ t("span", { className: o.categorySuggestionsTitle, children: i.title })
                  ] })
                }
              ) }, s)
            },
            `category-suggestion-${s}`
          );
        }) }) })
      ] });
    }
  )
), Fe = e.object({
  linkSuggestions: e.array(
    e.object({
      url: e.string(),
      name: e.string()
    })
  ),
  settings: e.object({
    heading: v.optional(),
    layout: F.optional()
  }).optional().describe("Settings for the link suggestions section"),
  clickHandler: e.function().args(e.string()).returns(e.void()).optional(),
  variants: e.custom().optional()
}), rt = S(
  "LinkSuggestionsList",
  g(
    Fe,
    ({ settings: a, linkSuggestions: n, clickHandler: l, variants: r }) => {
      const c = f(), o = ie.styles(r);
      return /* @__PURE__ */ m(I, { layout: a == null ? void 0 : a.layout, children: [
        /* @__PURE__ */ t(
          L,
          {
            className: o.linkSuggestionsHeading,
            heading: c("Link_Suggestions_Heading"),
            ...a == null ? void 0 : a.heading
          }
        ),
        /* @__PURE__ */ t("ul", { className: o.linkSuggestions, children: /* @__PURE__ */ t(H, { mode: "popLayout", children: n.map((i, s) => /* @__PURE__ */ t(
          R.div,
          {
            initial: { opacity: 0, y: 10 },
            animate: { opacity: 1, y: 0 },
            exit: { opacity: 0, y: 10 },
            transition: {
              duration: 0.2,
              delay: s * 0.05
            },
            children: /* @__PURE__ */ t("li", { children: /* @__PURE__ */ t(
              "button",
              {
                type: "button",
                className: o.linkSuggestionsButton,
                onClick: () => l && l(i.url),
                children: i.name
              }
            ) }, s)
          },
          `link-suggestion-${s}`
        )) }) })
      ] });
    }
  )
), we = e.object({
  phrases: e.array(e.string()),
  settings: e.object({
    heading: v.optional(),
    layout: F.optional()
  }).optional().describe("Settings for the autocomplete phrases section"),
  clickHandler: e.function().args(e.string()).returns(e.void()).optional(),
  variants: e.custom().optional()
}), lt = S(
  "PhraseSuggestionList",
  g(
    we,
    ({ settings: a, phrases: n, clickHandler: l, variants: r }) => {
      var i;
      const c = f(), o = se.styles(r);
      return /* @__PURE__ */ m(I, { layout: a == null ? void 0 : a.layout, children: [
        /* @__PURE__ */ t(
          L,
          {
            className: o.heading,
            heading: c("Search_Suggestions_Heading"),
            variants: (i = a == null ? void 0 : a.heading) == null ? void 0 : i.variants
          }
        ),
        /* @__PURE__ */ t("ul", { className: o.suggestionlist, children: /* @__PURE__ */ t(H, { mode: "popLayout", children: n.map((s, u) => /* @__PURE__ */ t(
          R.div,
          {
            initial: { opacity: 0, y: 10 },
            animate: { opacity: 1, y: 0 },
            exit: { opacity: 0, y: 10 },
            transition: {
              duration: 0.2,
              delay: u * 0.05
            },
            children: /* @__PURE__ */ t("li", { children: /* @__PURE__ */ t(
              "button",
              {
                type: "button",
                className: o.suggestionListButton,
                onClick: () => l && l(s),
                children: s
              }
            ) }, u)
          },
          `phrase-${u}`
        )) }) })
      ] });
    }
  )
), xe = e.object({
  variants: e.custom().optional(),
  settings: e.object({
    layout: F.optional(),
    heading: v.optional().describe("Heading for the autocomplete products section")
  }).optional().describe("Settings for the autocomplete products section"),
  products: e.array(e.custom().describe("Product object from Grease")).describe("List of products to display in the autocomplete")
}), ct = S(
  "ProductList",
  g(xe, ({ variants: a, settings: n, products: l }) => {
    var o;
    const r = f(), c = re.styles(a);
    return /* @__PURE__ */ m(I, { layout: n == null ? void 0 : n.layout, children: [
      /* @__PURE__ */ t(
        L,
        {
          className: c.heading,
          heading: r("Search_Suggestions_Products_Heading"),
          variants: (o = n == null ? void 0 : n.heading) == null ? void 0 : o.variants
        }
      ),
      /* @__PURE__ */ t("div", { className: c.productSuggestionList, children: /* @__PURE__ */ t(H, { mode: "popLayout", children: l.map((i, s) => /* @__PURE__ */ t(
        R.div,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
          transition: {
            duration: 0.25
          },
          children: /* @__PURE__ */ t(
            O,
            {
              product: i,
              context: {
                type: "plp",
                position: s
              },
              children: /* @__PURE__ */ t(V, {})
            },
            s
          )
        },
        `product-${s}`
      )) }) })
    ] });
  })
), We = e.object({
  phrases: e.array(e.string()),
  settings: e.object({
    heading: v.optional(),
    layout: F.optional()
  }).optional().describe("Settings for the autocomplete phrases section"),
  clickHandler: e.function().args(e.string()).returns(e.void()).optional(),
  variants: e.custom().optional()
}), ut = S(
  "RecentSearchesList",
  g(
    We,
    ({ settings: a, phrases: n, clickHandler: l, variants: r }) => {
      const c = f(), o = le.styles(r);
      return /* @__PURE__ */ m(I, { layout: a == null ? void 0 : a.layout, children: [
        /* @__PURE__ */ t(
          L,
          {
            className: o.recentSearchesHeading,
            heading: c("Recent_Searches_Heading"),
            ...a == null ? void 0 : a.heading
          }
        ),
        /* @__PURE__ */ t("ul", { className: o.recentSearches, children: /* @__PURE__ */ t(H, { mode: "popLayout", children: n.slice(-5).reverse().map((i, s) => /* @__PURE__ */ t(
          R.div,
          {
            initial: { opacity: 0, y: 10 },
            animate: { opacity: 1, y: 0 },
            exit: { opacity: 0, y: 10 },
            transition: {
              duration: 0.2,
              delay: s * 0.05
            },
            children: /* @__PURE__ */ t("li", { children: /* @__PURE__ */ t(
              "button",
              {
                type: "button",
                className: o.recentSearchesButton,
                onClick: () => l && l(i),
                children: i
              }
            ) }, s)
          },
          `phrase-${s}`
        )) }) })
      ] });
    }
  )
), $e = e.object({
  variants: e.custom().optional(),
  searchQuery: e.string(),
  heading: v.optional(),
  searchInput: $.optional(),
  layout: Ce.shape.layout.optional()
}), pt = S(
  "SearchResultsHeader",
  g(
    $e,
    ({ searchQuery: a, heading: n, searchInput: l, layout: r, variants: c }) => {
      const o = ce.styles(c), i = G(), s = i && i.length === 0, u = f();
      return /* @__PURE__ */ m(I, { className: o.wrapper, layout: { ...r }, children: [
        /* @__PURE__ */ t(D, { className: o.searchInput, ...l }),
        /* @__PURE__ */ t(
          L,
          {
            className: o.heading,
            heading: s ? u("Search_No_Results", {
              query: a ?? ""
            }) : u("Search_Title", { query: a ?? "" }),
            ...n
          }
        )
      ] });
    }
  )
);
export {
  ke as AutocompleteEmptyState,
  He as Beijing,
  st as CategorySuggestionsList,
  rt as LinkSuggestionsList,
  lt as PhraseSuggestionList,
  ct as ProductList,
  ut as RecentSearchesList,
  it as Search,
  Pe as SearchAutocomplete,
  D as SearchInput,
  pt as SearchResultsHeader,
  Be as Shanghai,
  Re as TemplateSelector,
  Te as categorySuggestionsListSchema,
  Fe as linkSuggestionsListSchema,
  we as phraseSuggestionListSchema,
  xe as productListSchema,
  We as recentSearchesListSchema,
  _e as searchAutocompleteSchema,
  X as searchBeijingSchema,
  $ as searchInputSchema,
  $e as searchResultsHeaderSchema,
  Ae as searchSchema,
  J as searchShanghaiSchema,
  Y as templateSelectorSchema
};
//# sourceMappingURL=index.es.js.map
